<template>
  <div class="GlobalTable">
    <GlobalTable ref="GlobalTable" v-loading="loading" :columns="tableColumns" :data="this.seachDataList"
      :currentPage="page.pageNum" :total="this.page.total" @handleCurrentChange="handleCurrentChange">
      <!-- 用户头像 -->
      <el-table-column label="用户头像" slot="headImg" align="center">
        <template slot-scope="{ row }">
          <span v-if="row.headImg">
            <img :src="row.headImg" width="40" height="40"  @click="seeImg(row)"/>
          </span>
          <span v-else>
            暂未上传
          </span>
        </template>
      </el-table-column>
      <!-- 用户昵称 -->
      <el-table-column label="用户昵称" slot="uName" align="center">
        <template slot-scope="{ row }">
          <span>
            {{ row.nickName || '--' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="入驻方式" slot="inType" align="center">
        <template slot-scope="{ row }">
          <span>
            {{
              row.inType == "01"
              ? "自主入驻"
              : row.inType == "02"
                ? "店员分享"
                : row.inType == "03"
                  ? "门店扫码"
                  : "顾客分享"
            }}</span>
        </template>
      </el-table-column>
      <el-table-column label="分享人/分享门店" slot="share" align="center">
        <template slot-scope="{ row }">
          <span v-if="row.inType === '01'">无</span>
          <span v-else-if="row.inType === '02'">{{ row.shareStaffName ? row.shareStaffName : "微信用户" }}-{{ row.shareStoreName
          }}</span>
          <span v-else-if="row.inType === '03'">{{ row.shareStoreName ? row.shareStoreName : "微信用户" }}</span>
          <span v-else-if="row.inType === '04'">{{ row.shareUserMobile }}</span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column label="下单数量" slot="orderNum" align="center">
        <template slot-scope="{ row }">
          <span @click="orderNumLink(row.mobile)" class="textdown" v-if="row.orderNum">{{ row.orderNum }}</span>
          <span v-else>{{ row.orderNum }}</span>
        </template>
      </el-table-column>
      <!-- 本机机型 -->
      <el-table-column label="本机机型" slot="fenhaoGoodsName" align="center">
        <template slot-scope="{ row }">
          <span @click="benjiClick(row)" :class="{ textdown: row.fenhaoGoodsName }" v-if="row.fenhaoGoodsName">{{ row.fenhaoGoodsName || '--' }}</span>
          <span v-else>{{ row.fenhaoGoodsName || '--' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="估价机型" slot="assessModelNum" align="center">
        <template slot-scope="{ row }">
          <span @click="assessClick(row)" :class="{ textdown: row.assessModelNum }">{{ row.assessModelNum }}</span>
        </template>
      </el-table-column>
      <el-table-column label="评估次数" slot="assessRecordNum" align="center">
        <template slot-scope="{ row }">
          <span>{{ row.assessRecordNum }}</span>
          <!-- @click="assessClick(row)" -->
          <!-- :class="{ textdown: row.assessRecordNum }" -->
        </template>
      </el-table-column>
      <el-table-column label="可用积分" slot="growPoints" align="center">
        <template slot-scope="{ row }">
          <span @click="pointClick(row)" :class="{ textdown: row.growPoints }">{{ row.growPoints }}</span>
        </template>
      </el-table-column>
    </GlobalTable>
    <!-- 本机机型列表弹框 -->
    <el-dialog title="本机机型" :visible.sync="benjiDialogVisible" :close-on-click-modal="false" width="600px"
      @closed="benjiDialogVisible = false">
      <div v-if="benjidataList.length > 0">
        <GlobalTable class="mt-20" style='padding-bottom:20px;' ref="GlobalTable" :columns="benjiColumnsDialog"
          :data="benjidataList" :maxHeight="500" :isPagination="false">
        </GlobalTable>
      </div>
      <div class="none-Data" v-else>
        暂无数据
      </div>
      <div style="
          padding-bottom: 20px;
          box-sizing: border-box;
          display: flex;
          justify-content: flex-end;
        ">
        <el-button size="small" @click="benjiDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
    <DialogTbale :show="orderDialogVisible" :loading="loading" title="估价历史" :columns="tableColumnsDialog" :data="dataList"
      ref="multipleTable" :currentPage="dialogPage.pageNum" :total="dialogPage.total" :pageSize="dialogPage.pageSize"
      :width="1200" @onClose="orderDialogVisible = false" @handleCurrentChange="dialogCurrentChangeDialog">
      <div class="flex-al flexwarp">
        <div class="flex-al mb-20">
          <label class="label">机型名称</label>
          <el-input v-model="orderFormData.goodsName" size="mini" placeholder="请输入机型名称"></el-input>
        </div>
        <div class="flex-al mb-20" style="margin-left: 30px">
          <label class="label">估价时间</label>
          <el-date-picker type="daterange" size="mini" v-model="orderTime" range-separator="~" start-placeholder="起始时间"
            end-placeholder="截止时间" :clearable="true">
          </el-date-picker>
        </div>

        <div style="flex-al: 1; margin-left: 20px" class="mb-20">
          <el-button size="mini" type="primary" @click="orderSearch">
            查询
          </el-button>
        </div>
      </div>
      <!-- 机型名称 -->
      <el-table-column label="机型名称" slot="goodsName" align="center">
        <template slot-scope="{ row }">
          <span>{{
            row.goodsName }}</span>
          <span class="benji" v-if="row.isLocal">本机</span>
        </template>
      </el-table-column>
      <el-table-column label="上次预估价" slot="userShowLastPrice" align="center">
        <template slot-scope="{ row }">
          <span >{{
            row.userShowLastPrice ? "￥" + row.userShowLastPrice : "0"
          }}</span>
           <div v-if="row.showPriceTypeLast !=='01'">￥{{row.leftSideShowPriceLast||0}}~￥{{row.rightSideShowPriceLast||0}}</div>
        </template>
      </el-table-column>
      <el-table-column label="当前价格" slot="userShowThisPrice" align="center">
        <template slot-scope="{ row }">
          <span >{{
            row.userShowThisPrice ? "￥" + row.userShowThisPrice : "0"
          }}</span>
           <div v-if="row.showPriceType !=='01'">￥{{row.leftSideShowPrice||0}}~￥{{row.rightSideShowPrice||0}}</div>
        </template>
      </el-table-column>
      <el-table-column label="估价时间" slot="assessTime" align="center">
        <template slot-scope="{ row }">
          <span>{{ row.assessTime }}</span>
        </template>
      </el-table-column>
      <el-table-column label="议价申请" slot="expectedNum" align="center">
        <template slot-scope="{ row }">
          <span @click="tolink" :class="{ textdown: row.expectedNum }">{{
            row.expectedNum ? row.expectedNum : "0"
          }}</span>
        </template>
      </el-table-column>
      <div slot="tableFooter" style="
          padding-bottom: 20px;
          box-sizing: border-box;
          display: flex;
          justify-content: flex-end;
        ">
        <el-button size="small" type="primary" @click="orderCommit">确定</el-button>
      </div>
    </DialogTbale>

    <!-- 积分 -->

    <DialogTbale :show="pointDialogVisible" :loading="pointloading" title="可用积分" :columns="pointTableColumnsDialog"
      :data="pointList" ref="multipleTable" :currentPage="pointPage.pageNum" :total="pointPage.total"
      :pageSize="pointPage.pageSize" :width="1200" @onClose="pointDialogVisible = false"
      @handleCurrentChange="pointCurrentChangeDialog">
      <div class="flex-al flexwarp">
        <div class="flex-al mb-20">
          <label class="label">选择类型</label>
          <el-select size="mini" v-model="pointFormData.opt" @change="optChange">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="item in pointOption" :key="item.opt" :label="item.opt == '01' ? '增加' : '减少'"
              :value="item.opt"></el-option>
          </el-select>
        </div>
        <div class="flex-al mb-20" style="margin-left: 30px">
          <label class="label">子类型</label>
          <el-select size="mini" v-model="pointFormData.serType">
            <el-option v-for="item in serTypeOption" :key="item.serType" :label="item.serName"
              :value="item.serType"></el-option>
          </el-select>
        </div>
        <div class="flex-al mb-20" style="margin-left: 30px">
          <label class="label">变动时间</label>
          <el-date-picker type="daterange" size="mini" v-model="pointTime" range-separator="~" start-placeholder="起始时间"
            end-placeholder="截止时间" :clearable="true">
          </el-date-picker>
        </div>

        <div style="flex-al: 1; margin-left: 20px" class="mb-20">
          <el-button size="mini" type="primary" @click="pointSearch">
            查询
          </el-button>
        </div>
      </div>
      <el-table-column label="变动类型" slot="opt" align="center">
        <template slot-scope="{ row }">
          <span>{{ row.opt == "01" ? "增加" : "减少" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="变动积分" slot="points" align="center">
        <template slot-scope="{ row }">
          <span v-if="row.points > 0">{{
            row.opt == "01" ? "+" + row.points : "-" + row.points
          }}</span>
          <span v-else>0</span>
        </template>
      </el-table-column>
      <el-table-column label="关联订单" slot="orderNo" align="center">
        <template slot-scope="{ row }">
          <span @click="noticeLink(row.orderNo)" v-if="row.orderNo" class="textdown">{{ row.orderNo }}</span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <div slot="tableFooter" style="
          padding-bottom: 20px;
          box-sizing: border-box;
          display: flex;
          justify-content: flex-end;
        ">
        <el-button size="small" type="primary" @click="pointCommit">确定</el-button>
      </div>
    </DialogTbale>
    <!-- 预览头像 -->
    <el-image-viewer
      v-if="showViewer"
      :on-close="
        () => {
          showViewer = false;
        }
      "
      :url-list="imgList"
    />
  </div>
</template>

<script>
import MinXinRequest from "@/mixins/request";
import _api from "@/utils/request";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import moment from "moment";

export default {
  name: "Table",
  mixins: [MinXinRequest],
  components: { ElImageViewer },
  data() {
    return {
      showViewer: false,//预览头像
      imgList: [],//预览头像
      // 本机机型列表弹框
      benjiDialogVisible: false,
      benjiColumnsDialog:[
      { label: "获取本机机型", prop: "fenhaoGoodsName" },
      { label: "获取时间", prop: "getTime" }
      ],
      benjidataList:[],
      userId: "",
      // ****************
      page: {
        total: 0,
        pageNum: 1,
        pageSize: 10,
      },
      loading: false,
      pointloading: false,
      orderTime: null,
      pointTime: null,
      orderDialogVisible: false,
      pointDialogVisible: false,
      //////////列表
      seachDataList: [],
      curPhone: "",
      ////////
      tableColumns: [
        // { label: "用户名称", prop: "nickName" },
        { label: "用户手机号", prop: "mobile" },
        { slotName: "headImg" },
        { slotName: "uName" },
        { slotName: "inType" },
        { slotName: "share" },
        { slotName: "orderNum" },
        { slotName: "fenhaoGoodsName" },
        { slotName: "assessModelNum" },
        { slotName: "assessRecordNum" },
        { slotName: "growPoints" },
        { label: "入驻时间", prop: "createTime" },
        { label: "最近估价时间", prop: "assessLastTime" },
        { label: "最近登录时间", prop: "lastLoginTime" },
      ],
      pointTableColumnsDialog: [
        // { label: "变动类型", prop: "orderType" },
        { slotName: "opt" },
        { label: "子类型", prop: "title" },
        { slotName: "points" },
        { label: "可用积分", prop: "usablePoints" },
        { label: "变动时间", prop: "createTime" },
        { slotName: "orderNo" },
      ],
      tableColumnsDialog: [
        // { label: "机型名称", prop: "goodsName" },
        { slotName: "goodsName" },
        { label: "估价次数", prop: "assessRecordNum" },
        { slotName: "userShowLastPrice" },
        { slotName: "userShowThisPrice" },
        { slotName: "assessTime" },
        { slotName: "expectedNum" },
      ],
      dataList: [],
      dialogPage: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      pointPage: {
        total: 0,
        pageNum: 1,
        pageSize: 10,
      },
      orderFormData: {
        endTime: "",
        startTime: "",
        goodsName: "",
        userId: "",
        opt: "",
        serType: "",
      },
      pointList: [],
      pointFormData: {
        endTime: "",
        startTime: "",
        goodsName: "",
        userId: "",
        serType: "",
      },
      pointOption: [],
      serTypeOption: [],
    };
  },
  computed: {
    SeachParams() {
      return this.$store.state.tagsView.SeachParams;
    },
  },
  created() {
    this.handleCurrentChange(1);
    // this.getPointsType();
  },
  watch: {
    SeachParams(newVal) {
      console.log(newVal);
      this.handleCurrentChange();
    },
  },
  methods: {
    // 预览头像
    seeImg(val) {
      console.log(val);
      this.imgList = [];
      this.showViewer = true;
      this.imgList.push(val.headImg);
    },
    // 本机机型
    // 查看
    benjiClick(row) {
      console.log(row);
      this.userId = row.id;
      this.handleBenjiCurrentChangeDialog();
    },
    handleBenjiCurrentChangeDialog(){
      this.loading = true;
      _api
        .userMachineList({userId:this.userId})
        .then((res) => {
          if(res.code==1){
            this.benjiDialogVisible = true;
            console.log(res);
          this.benjidataList = res.data;
          this.loading = false;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    // 详情
    noticeLink(orderNo) {
      let routeData = this.$router.resolve({
        path: "/OnlinreyService/OrderDetails",
        query: {
          orderNo,
        },
      });
      window.open(routeData.href, "_blank");
    },
    // 表格切换页面
    handleCurrentChange(val) {
      console.log(val);
      // const baseRequest = {
      //   storeManager: this.SeachParams.storeManager,
      //   storeManagerPhone: this.SeachParams.staffMobile,
      //   storeName: this.SeachParams.storeName,
      //   pageNum: val ? val : this.SeachParams.pageNum,
      //   pageSize: 10,
      // };
      const baseRequest = {
        name: this.SeachParams.name,
        mobile: this.SeachParams.mobile,
        inType: this.SeachParams.inType,
        endTime: this.SeachParams.endTime,
        startTime: this.SeachParams.startTime,
        pageNum: val ? val : this.SeachParams.pageNum,
        pageSize: 10,
      };
      _api.userList(baseRequest).then((res) => {
        if (res.code === 1) {
          this.seachDataList = res.data.records;
          this.page.total = res.data.total;
          this.page.pageNum = res.data.current;
          this.$store.commit("tagsView/POST_STAFF", this.seachDataList);
        }
        if (typeof this.SeachParams.disuseLoding === 'function') {
          this.SeachParams.disuseLoding();
        }
      }).catch(() => {
        if (typeof this.SeachParams.disuseLoding === 'function') {
          this.SeachParams.disuseLoding();
        }
      });
    },
    // 积分类型
    getPointsType() {
      _api.pointsType().then((res) => {
        console.log(res);
        this.pointOption = res.data;
      });
    },
    // 估价机型
    assessClick(row) {
      console.log(row);
      this.curPhone = row.mobile;
      this.orderFormData.userId = row.id;
      this.dialogPage.pageNum = 1;
      this.dialogCurrentChangeDialog();
      this.orderDialogVisible = true;
    },
    // 估价历史弹窗
    // 查询
    orderSearch() {
      this.dialogCurrentChangeDialog(1);
    },
    dialogCurrentChangeDialog(val) {
      this.loading = true;
      if (this.orderTime) {
        this.orderFormData.startTime = new Date(this.orderTime[0]).getTime();
        this.orderFormData.endTime = new Date(this.orderTime[1]).getTime() + 86399000;
      } else {
        this.orderFormData.startTime = "";
        this.orderFormData.endTime = "";
      }
      if (val) {
        this.dialogPage.pageNum = val;
      }
      let params = {
        pageNum: this.dialogPage.pageNum,
        pageSize: this.dialogPage.pageSize,
        startTime: this.orderFormData.startTime,
        endTime: this.orderFormData.endTime,
        goodsName: this.orderFormData.goodsName,
        userId: this.orderFormData.userId,
      };
      _api
        .assessHistory(params)
        .then((res) => {
          this.dataList = res.data.records;
          // this.dataList.forEach((item) => {
          //   item.assessTime = moment(
          //     new Date(item.assessTime).getTime()
          //   ).format("YYYY.MM.DD");
          // });
          this.dialogPage.pageNum = res.data.current;
          this.dialogPage.total = res.data.total;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    orderCommit() {
      this.orderDialogVisible = false;
    },
    // 议价申请
    tolink() {
      this.$router.push(
        `/OnlinreyService/ApplicationBargain?curPhone=${this.curPhone}`
      );
    },
    // 积分弹框
    pointSearch() {
      this.pointCurrentChangeDialog(1);
    },
    pointClick(row) {
      this.pointFormData.opt = "";
      this.pointFormData.serType = "";
      this.pointFormData.userId = row.id;
      this.pointDialogVisible = true;
      this.getPointsType();
      this.pointCurrentChangeDialog(1);
    },
    pointCurrentChangeDialog(val) {
      this.pointloading = true;
      if (this.pointTime) {
        this.pointFormData.startTime = new Date(this.pointTime[0]).getTime();
        this.pointFormData.endTime = new Date(this.pointTime[1]).getTime() + 86399000;
      } else {
        this.pointFormData.startTime = "";
        this.pointFormData.endTime = "";
      }
      if (val) {
        this.pointPage.pageNum = val;
      }
      let params = {
        pageNum: this.pointPage.pageNum,
        pageSize: this.pointPage.pageSize,
        startTime: this.pointFormData.startTime,
        endTime: this.pointFormData.endTime,
        goodsName: this.pointFormData.goodsName,
        userId: this.pointFormData.userId,
        serType: this.pointFormData.serType,
        opt: this.pointFormData.opt,
      };
      _api
        .pointsRecord(params)
        .then((res) => {
          this.pointList = res.data.records;
          // this.pointList.forEach((item) => {
          //   item.assessTime = moment(
          //     new Date(item.assessTime).getTime()
          //   ).format("YYYY.MM.DD");
          // });
          this.pointPage.pageNum = res.data.current;
          this.pointPage.total = res.data.total;
          this.pointloading = false;
        })
        .catch((err) => {
          this.pointloading = false;
        });
    },
    pointCommit() {
      this.pointDialogVisible = false;
    },
    orderNumLink(mobile) {
      this.$router.push(`/OnlinreyService/onlineOrder?mobile=${mobile}`);
    },
    optChange(e) {
      if (!e) {
        this.serTypeOption = [];
        this.pointFormData.serType = "";
        return;
      }
      console.log(this.pointOption);
      this.pointOption.forEach((item) => {
        if (item.opt === e) {
          this.serTypeOption = item.levelViews;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
 .none-Data {
    width: 100%;
    height: 100px;
    text-align: center;
    line-height: 100px;
    font-size: 22px;
    color: #666;
  }
.benji {
  background: #fba516;
  border-radius: 4px;
  padding: 2px;
  line-height: 20px;
  font-size: 12px;
  color: #ffffff;
  margin-left: 6px;
}

.GlobalTable {
  /deep/ .form_input .el-input__inner {
    height: 30px !important;
  }

  .dialog-tip {
    font-size: 12px;
    color: #ff687b;
  }

  .widQus {
    width: 96%;
    margin: 15px auto;
  }

  .qustion-top {
    display: flex;
    align-items: center;
    height: 20px;
    margin-bottom: 15px;

    img {
      width: 18px;
      object-fit: contain;
      margin-right: 5px;
    }

    div {
      font-size: 14px;
      font-family: FZLanTingHei-M-GBK;
      font-weight: 400;
      color: #ff687b;
      line-height: 0px;
    }
  }

  .box-qustion {
    // min-height: 276px;
    max-height: 400px;
    overflow: hidden;
    overflow-y: scroll;
    background: #f5f5f5;
    border-radius: 4px;
  }

  .flex {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .flex-al {
    display: flex;
    align-items: center;
  }

  .flex-jb {
    display: flex;
    justify-content: space-between;
  }

  .flexwarp {
    display: flex;
    flex-wrap: wrap;
  }

  .mb-20 {
    margin-bottom: 20px;
  }

  .textdown {
    color: #0981ff;
    cursor: pointer;
    text-decoration: underline;
  }

  .label {
    white-space: nowrap;
    margin-right: 10px;
    width: 56px;
  }
}
</style>
